<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Screen from "../../../../components/screen";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
// import Search from "@/components/c-select-search";
import Search from "@/components/c-select-search";
import Browse from "@/components/c-select-browse";
import Loading from "@/components/c-loading";
import InvoiceRow from "@/components/invoice-row";
import { itemtransactiondetailService } from "../../../../services/inventoryservice/itemtransactiondetail.service";
import { itemtransactionService } from "../../../../services/inventoryservice/itemtransaction.service";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Invoice Form",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select,
    Browse,
    Search,
    InvoiceRow
  },
  watch: {
    valueType: function(newVal) { // watch it
      // console.log(newVal);
      this.loadingStatus(newVal);

      this.valueStatus = newVal == 1 ? 2 : 6;
    }
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Item",
      breadCrumb: {},
      invoiceData: null,
      supplierData: {},
      statusData: {},
      statusDataAll: [],
      typeData: {},
      categoryData: {},
      itemData: {},
      allItemData: {},
      
      valueNumber: '',
      valueDate: this.$moment().clone().format('YYYY-MM-DD'),
      valueSupplier: 0,
      valueStatus: 2,
      valueType: 0,
      valueNotation: '',
      valueRef: '',
      valueTotal: 0,
      valueEntries: [],

      valueItem: 0,
      valueCategory: 0,

      valueHide: false,
      
    };
  },
  mounted() {
    
    // this.valueStatus = 1;
    this.valueType = 1;

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } else {
      this.loadingData(0);
    }
  },

  methods: {
    loadingData: function(id) {
      this.fetchingStats = false;
      itemtransactionService.getOne(id)
        .then(response => {
          if(response.data) {
            this.breadCrumb = {
              text: response.data.number,
              active: true,
            };

            this.loadingEntryData(id);

            this.invoiceData = response;

            this.valueNumber = this.invoiceData.data.number;
            this.valueDate = this.invoiceData.data.transaction_date;
            this.valueSupplier = this.invoiceData.data.supplier_id;
            this.valueStatus = this.invoiceData.data.item_transaction_status_id;
            this.valueType = this.invoiceData.data.type_id;
            this.valueNotation = this.invoiceData.data.notation;
            this.valueRef = this.invoiceData.data.ref;
          }

          this.fetchingStats = true;
          // this.invoiceData = response;

          this.statusDataAll = response.setting.itemtransactionstatuses;
          this.supplierData = {data: response.setting.suppliers};
          this.categoryData = {data: response.setting.categories};
          this.itemData = {data: response.setting.items};
          this.allItemData = response.setting.items;
          this.loadingStatus(this.valueType);


          // console.log(JSON.stringify(this.allItemData));
          
        });
    },

    loadingEntryData: function(id) {

      itemtransactiondetailService.getListByTransaction(id)
        .then(response => {

          this.valueEntries = response.data;   
          console.log(JSON.stringify(this.valueEntries));
               
        });
    },

    loadingStatus: function(typeId) {

      this.statusData = {
        data: this.statusDataAll.filter(obj => obj.item_transaction_type_id == typeId)
      };
    },

    categoryChanged: function(id) {
      // console.log(id);

      if(id == 0) {
        this.itemData = {data: this.allItemData};
      } else {
        this.itemData = {data: this.allItemData.filter(obj => obj.category_id == id)};
      }
    },

    itemChanged: function(item) {
      // console.log(item);
      let row = {
        id: item.id ? item.id : 0,
        label: item.label,
        item_id: item.id,
        quantity: 1,
        price: item.price
      };

      if(this.valueEntries.length > 0) {

        let selected = this.valueEntries.find(obj => obj.item_id == item.id);
        if(selected == null) {
          this.valueEntries.push(row);
        }

      } else {
        this.valueEntries.push(row);
      }

      this.valueItem = 0;
    },

    formatCurrency(value, sign = '', decimal = '.00') {
      return  sign.length > 1 ? sign + this.$options.filters.numFormat(value, `0,0${decimal}`) : this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },

    getTotal() {
      return this.valueEntries.reduce((sum, val) => sum + (val.price * val.quantity), 0);
    },
    

    submitCancel: function() {

      // console.log(this.dataType);

      this.$swal.fire({
        title: i18n.t('general.cancel-confirm.title'),
        text: i18n.t('general.cancel-confirm.message'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t('general.cancel-confirm.yes'),
        cancelButtonText: i18n.t('general.cancel')
      }).then(result => {
        if (result.value) {

          this.$router.push(this.$route.query.redirectFrom || {
              name: "invoice-list"
          });

        }
      });
      
    },
    submitSave: function() {

      this.tryingToSubmit = true;

      let entries = [];
      this.valueEntries.map((item) => {
        if(this.isAdd) {
          entries.push({
            item_id: item.item_id,
            qantity: item.quantity,
            price: item.price
          });
        } else {
          entries.push({
            id: item.id ? item.id : 0,
            item_id: item.item_id,
            qantity: item.quantity,
            price: item.price
          });
        }
      });

      let invoice = {

        number: this.valueNumber,
        transaction_date: this.valueDate,
        supplier_id: this.valueSupplier,
        item_transaction_status_id: this.valueStatus,
        type_id: this.valueType,
        notation: this.valueNotation,
        ref: this.valueRef,
        total: this.getTotal(),
        item_transaction_details: entries

      };

      console.log(JSON.stringify(invoice));

      if(this.isAdd) {
        itemtransactionService.insert(invoice)
         .then(response => {
           this.tryingToSubmit = false;
           if(response.status == 200) {
              this.clearForm();
              this.$swal.fire({
                title: i18n.t('general.success.title'),
                text: i18n.t('general.success.message'),
                icon: "success",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: i18n.t('general.success.yes'),
                cancelButtonText: i18n.t('general.success.no')
              }).then(result => {
                if (!result.value) {
                  this.$router.push(this.$route.query.redirectFrom || {
                    name: "invoice-list"
                  });
                } 
              });
           }
          
        });
      } else {
        console.log(JSON.stringify(invoice));
        itemtransactionService.update(this.$route.params.id, invoice)
         .then(response => {
          this.tryingToSubmit = false;

          if(response.status == 200) {
            this.$router.push(this.$route.query.redirectFrom || {
              name: "invoice-list"
            });

            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message-edit'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
      }
    },

    clearForm: function() {

      
    }, 

    rowChanged: function(item, index) {
      this.valueEntries[index] = item;
    },

    rowDeleted: function(index) {
      this.valueEntries.splice(index, 1);
    }, 

    onStatusChanged: function(arg) {
      console.log(arg);

      this.valueHide = (this.valueType == 1 && arg == 1);
      
    }

  }
};
</script>

<template>
  <Layout>
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('invoice.list'),
        href: '/additional/invoice',
      }, {
        text: $t('invoice.new'),
        active: true
      }]" :title="this.isAdd ? $t('invoice.new') : $t('invoice.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('invoice.list'),
        href: '/additional/invoice',
      }, this.breadCrumb]" :title="this.isAdd ? $t('invoice.new') : $t('invoice.edit')" />
    </div>

    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-8">
        <div>
          <div> 
            <div class="row">
              <div class="col-md-4">
                <Select 
                  @change="categoryChanged" 
                  :id="'category_id'"
                  v-model="valueCategory"
                  :list="this.categoryData"
                  :label="'category.text'"  />
              </div>
              <div class="col-md-4">
                <Browse 
                  @change="itemChanged" 
                  :id="'item_id'"
                  :list="this.itemData"
                  :label="'item.text'"  />
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body"> 
            
            <div class="row">
              <div class="col-md-5">{{$t('item.text')}}</div>
              <div class="col-md-2">{{$t('invoice.quantity')}}</div>
              <div v-show="!valueHide" class="col-md-2 text-end">{{$t('invoice.price')}}</div>
              <div v-show="!valueHide" class="col-md-2 text-end">{{$t('invoice.amount')}}</div>
              <div class="col-md-1 text-center"></div>
            </div>
            <div class="row" style="padding-top: 5px; padding-bottom: 10px;"><hr /></div>
            <InvoiceRow v-for="(entry, index) in valueEntries" :key="index"
              @changed="rowChanged"
              @deleted="rowDeleted"
              :isRequest="valueHide"
              :ref="`entry_${index}`"
              :index="index"
              :item="entry" />
          </div>
        </div>
        <div v-show="!valueHide" >
          <div > 
            <div class="row" style="font-size: 14pt;">
              <div class="col-md-9 text-end">{{`${$t('invoice.total')}:`}}</div>
              <div class="col-md-2 text-end">{{formatCurrency(getTotal(), '$')}}</div>
              <div class="col-md-1 text-center"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <b-form-group
                      class="mb-3"
                      :label="$t('invoice.type')"
                      :label-for="id"
                  >
                    <div class="input-group" style="margin-left: 10px;"> 
                      <b-form-group class="input-group" id="type">
                        <div inline class="row gy-2 gx-3 align-items-end">
                        <b-form-radio
                          v-model="valueType"
                          class="col-sm-auto"
                          value=1
                          plain
                          >{{$t('invoice.in')}}</b-form-radio>
                        <b-form-radio
                          v-model="valueType"
                          class="col-sm-auto"
                          value=2
                          plain
                          >{{$t('invoice.out')}}</b-form-radio>
                        </div>
                      </b-form-group>
                      
                    </div>
                  </b-form-group>
                </div>
                
         
              </div>

              <!-- <div class="col-md-6">
                <Select 
                  :id="'item_transaction_status_id'"
                  :list="this.statusData"
                  v-model="valueStatus"
                  :label="'invoice.status'"
                  @change="onStatusChanged"
                    /> 
              </div>
              -->
              
            </div>
            <div v-show="!valueHide" class="row">
              <div class="col-md-6">
                <Input 
                  :type="'text'"
                  :id="'number'"
                  v-model="valueNumber"
                  :label="'invoice.number'"
                    /> 
              </div>
              <div class="col-md-6">
                <Input 
                  :type="'text'"
                  :id="'ref'"
                  v-model="valueRef"
                  :label="'invoice.ref'"
                    /> 
              </div>
            </div>
            <div class="row">
              <div v-show="!valueHide" class="col-md-6">
                <Search 
                  :id="'supplier_id'"
                  :list="this.supplierData"
                  v-model="valueSupplier"
                  :label="'supplier.text'"
                    /> 
              </div>
              <div :class="valueHide ? 'col-md-12' : 'col-md-6'">
                <Input 
                  :type="'date'"
                  :id="'transaction_date'"
                  v-model="valueDate"
                  :label="'invoice.date'"
                    /> 
              </div>
            </div>
            
          </div>
        </div>
        <div class="card">
          <div class="card-body"> 
            <div class="row">
              <div class="col-md-6">
                <Button v-bind:icon="'bx bx-x-circle'" 
                  v-bind:buttonType="'button'"
                  v-bind:variant="'danger'"
                  @click="submitCancel()"
                  v-bind:title="$t('general.cancel')"  />
              </div>
              <div class="col-md-6">
                <Button v-bind:icon="'bx bx-save bx-tada'" 
                  v-bind:buttonType="'button'"
                  @click="submitSave()"
                  v-bind:requesting="tryingToSubmit"
                  v-bind:title="$t('general.save')"  />
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </b-form> 
  
  </Layout>
</template>